module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AgreementList'
      }
    }
  }, [_vm._v("Umowy")]), _vm._v("/Edycja/" + _vm._s(_vm.retrieved && _vm.retrieved.customerData.name) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'AgreementShow',
        params: {
          id: _vm.$route.params.id
        }
      },
      "title": "Powrót"
    }
  }, [_c('span', [_vm._v("Powrót")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.retrieveError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.retrieveError) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.updateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.updateError) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    ref: "agreementTab",
    attrs: {
      "card": "",
      "lazy": true
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Dane podstawowe",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('general')
      }
    }
  }, [_c('AgreementUpdateGeneral')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Faktury"
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('invoice')
      }
    }
  }, [_c('AgreementUpdateInvoice')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Dokumenty",
      "disabled": _vm.isTabDocumentDisabled
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('document')
      }
    }
  }, [_c('AgreementUpdateDocuments')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Zaliczki, Potrącenia, Zwroty",
      "disabled": _vm.isTabAdditionalDisabled
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('additional')
      }
    }
  }, [_c('AgreementUpdateDeduction')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Rozliczenie umowy",
      "disabled": _vm.isTabSettlementDisabled
    },
    on: {
      "click": function($event) {
        return _vm.showTab('settlement')
      }
    }
  }, [_c('AgreementUpdateSettlement')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec1018a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/Update.vue
// module id = 853
// module chunks = 0